export default __webpack_public_path__ + "img/google_for_jobs_qr_placeholder.121fcea3.webp";